import { useMemo } from 'react';
import { type Initiative, InitiativeStatus } from '../../../../../api/initiative-client/initiative-client.type';
import { transformData } from './table.helpers';
import type { Row } from './table.type';

/**
 * Hook that transforms and filters initiative data for the overview table
 *
 * @param {Initiative[] | undefined} initiatives - Array of initiatives to display in the table, or undefined if not loaded
 * @param {InitiativeStatus[]} selectedInitiativeStatuses - Array of initiative statuses to filter by
 * @returns {Row[]} Filtered array of table rows containing initiative data
 */
export const useInitiativeOverviewTableData = (
  initiatives: Initiative[] | undefined,
  selectedInitiativeStatuses: InitiativeStatus[],
): Row[] => {
  const tableData = useMemo(() => transformData(initiatives), [initiatives]);

  const filteredData = useMemo(() => {
    return selectedInitiativeStatuses.length > 0
      ? tableData.filter((row) => selectedInitiativeStatuses.includes(row.status))
      : tableData;
  }, [tableData, selectedInitiativeStatuses]);

  return filteredData;
};
